import React from 'react';
import useAuthorization from 'hooks/useAuthorization';
import { UserRole } from 'models/user';
import { useSelector } from 'react-redux';
import { TStore } from 'store';
import t from 'utils/translationHelper';

import { TradeDto } from '@alpha/fx-dtos/lib/responses/TradeDto';
import { ActionButton } from '@alpha/ui-lib/ui/button';
import { Button } from '@alpha/ui-lib/ui/external';
import { StyledDivider } from '@alpha/ui-lib/ui/StyledDivider';

import useStyles from './MassDrawdownActionBar.styles';

interface IMassDrawdownActionBar {
  selectedTrades: TradeDto[] | undefined;
  handleClearButtonClick: () => void;
  handleOpenDrawer: () => void;
  handleCancelMassDrawdown: () => void;
  show?: boolean;
}

const MassDrawdownActionBar: React.FC<IMassDrawdownActionBar> = (props: IMassDrawdownActionBar) => {
  const {
    selectedTrades,
    handleCancelMassDrawdown,
    handleClearButtonClick,
    handleOpenDrawer,
    show = false,
  } = props;

  const userId = useSelector<TStore, string | undefined>((store) => store.user.profileDetails?.id);
  const canInputDrawdown = useAuthorization([[UserRole.DRAWDOWN_INPUTTER, UserRole.FIRST_PARTY_DRAWDOWN_INPUTTER]]);

  const classes = useStyles();
  const rootClasses = [classes.root, show ? null : 'hide']?.join(' ');

  if (!userId) return <></>;

  const showApproveButton = canInputDrawdown.authorized;

  return (
    <div className={rootClasses}>
      <div className={classes.leftContent}>
        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
          <span className={classes.selectedTrades}>
            {selectedTrades ? selectedTrades.length : 0}
            {' '}
            {selectedTrades && (selectedTrades.length < 1 || selectedTrades.length > 1) ? t('trades^~') : t('trade^~')}
            {' '}
            {t('selected')}
          </span>

          {selectedTrades && selectedTrades.length > 0
       && (
       <div className={classes.selectedTradesCurrencyPair}>
         {selectedTrades?.[0]?.currencyPair?.slice(0, 3)}
         {' '}
         /
         {' '}
         {selectedTrades?.[0]?.currencyPair?.slice(4, 8)}
         {' '}
         {' '}
         {(() => {
           const currency = selectedTrades?.[0]?.currencyPair?.slice(8, 12);
           return currency ? currency.charAt(0).toUpperCase() + currency.slice(1) : '';
         })()}
       </div>
       )}
        </div>

        {selectedTrades && selectedTrades.length > 0 && (
          <>
            <StyledDivider vertical />
            <Button
              disableRipple
              className={classes.clearButton}
              onClick={handleClearButtonClick}
            >
              {t('clear_selection')}
            </Button>
          </>
        )}

        {selectedTrades && selectedTrades.length === 1 && (
        <div style={{ marginLeft: '10px', alignContent: 'center', marginTop: '-10px' }}>
          {t('please_select_more_than_one_forward_contract_to_continue')}
        </div>
        )}
      </div>

      <div className={classes.rightContent}>
        <>
          <ActionButton
            style={{ background: '#F7F7F7', color: '#212529' }}
            size="medium"
            testId="cancel-mass-drawdown-btn"
            onClick={handleCancelMassDrawdown}
            className={`${classes.cancelButton} cancel-mass-drawdown`}
          >
            {t('cancel_mass_drawdown')}
          </ActionButton>

          {showApproveButton && (
          <ActionButton
            size="medium"
            testId="new-mass-drawdown-btn"
            disabled={!selectedTrades?.length || selectedTrades?.length < 2}
            className={`${classes.approveButton} new-mass-drawdown`}
            onClick={handleOpenDrawer}
          >
            {t('new_mass_drawdown')}
          </ActionButton>
          )}
        </>

      </div>

    </div>
  );
};
export default MassDrawdownActionBar;
